import { render } from "./header.vue?vue&type=template&id=63226612&scoped=true&ts=true"
import script from "./header.ts?vue&type=script&lang=ts&external"
export * from "./header.ts?vue&type=script&lang=ts&external"

import "./header.scss?vue&type=style&index=0&id=63226612&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63226612"]])

export default __exports__